import React, { useState, useEffect, useCallback } from 'react';
import { BoldLink } from '@bold/web-components-react';
import useViewport from 'hooks/useViewport';
import Category from './Category';

import './security-cards.scss';

const SecurityCards = ({ cards }) => {
  const { isMobile, isTablet, isDesktop } = useViewport();
  const [numberToShow, setNumberToShow] = useState(3);

  const securityRecomendations = cards.cards ? cards.cards : cards;

  const getInitialNumberToShow = useCallback(() => {
    if (isMobile) {
      return 3;
    }
    if (isTablet) {
      return 6;
    }
    if (isDesktop) {
      return 8;
    }

    return 0;
  }, [isMobile, isTablet, isDesktop]);

  useEffect(() => {
    setNumberToShow(getInitialNumberToShow());
  }, [getInitialNumberToShow]);

  const handleclick = () => {
    if (numberToShow < securityRecomendations.length) {
      setNumberToShow(prevState => prevState + numberToShow);
    } else {
      setNumberToShow(getInitialNumberToShow());
    }
  };

  return (
    <div className="security-recomendations-card">
      <div className="section-container">
        <div className="section-grid">
          {securityRecomendations.slice(0, numberToShow).map(({ icon, title, info, badge, isRender }, i) => (
            <div key={`card-item-${i + 1}`} className="card">
              <Category {...{ badge }} />
              <div className="card-title">
                {icon}
                <h4>{title}</h4>
              </div>
              {isRender ? <div dangerouslySetInnerHTML={{ __html: info }}></div> : <p>{info}</p>}
            </div>
          ))}
        </div>
        {securityRecomendations.length > getInitialNumberToShow() && (
          <BoldLink color="accent" onClick={handleclick}>
            {numberToShow >= securityRecomendations.length ? 'Ver menos' : 'Ver más'}
          </BoldLink>
        )}
      </div>
    </div>
  );
};

export default SecurityCards;
